var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEcpm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.26953 8.37516C8.26953 8.85034 8.4583 9.30606 8.7943 9.64206C9.1303 9.97806 9.58602 10.1668 10.0612 10.1668C10.5364 10.1668 10.9921 9.97806 11.3281 9.64206C11.6641 9.30606 11.8529 8.85034 11.8529 8.37516C11.8529 7.89998 11.6641 7.44427 11.3281 7.10826C10.9921 6.77226 10.5364 6.5835 10.0612 6.5835C9.58602 6.5835 9.1303 6.77226 8.7943 7.10826C8.4583 7.44427 8.26953 7.89998 8.26953 8.37516Z",
    stroke: "#125F64",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1312 13.6819C10.7819 13.7267 10.4256 13.7494 10.0625 13.75C6.8375 13.75 4.15 11.9583 2 8.375C4.15 4.79167 6.8375 3 10.0625 3C12.7548 3 15.0723 4.24849 17.0151 6.74548M18.125 11.0625H15.8854C15.529 11.0625 15.1872 11.2041 14.9352 11.4561C14.6832 11.7081 14.5417 12.0499 14.5417 12.4063C14.5417 12.7626 14.6832 13.1044 14.9352 13.3564C15.1872 13.6084 15.529 13.75 15.8854 13.75H16.7812C17.1376 13.75 17.4794 13.8916 17.7314 14.1436C17.9834 14.3956 18.125 14.7374 18.125 15.0938C18.125 15.4501 17.9834 15.7919 17.7314 16.0439C17.4794 16.2959 17.1376 16.4375 16.7812 16.4375H14.5417M16.3333 16.4375V17.3333M16.3333 10.1667V11.0625",
    stroke: "#125F64",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcpm);
export default __webpack_public_path__ + "static/media/ecpm.bb589f4e52000c9ea9785a38f72a2bee.svg";
export { ForwardRef as ReactComponent };